const ALL_CATEGORY = "All";
const normalizeFilteredFaqCategories = (categories) => (categories ?? []).filter((category) => {
  var _a;
  return (category == null ? void 0 : category.id) && ((_a = category.label) == null ? void 0 : _a.trim());
});
export {
  ALL_CATEGORY,
  normalizeFilteredFaqCategories
};
